import { legalRoutes } from 'config/legalRoutes'

import { SUPPLIERS_BY_TAG } from './constants'

export const jackpotsFromProvidersConfig = {
  feature: {
    apiUrl: process.env.JACKPOTS_TICKERS as string,
    suppliersByTag: SUPPLIERS_BY_TAG,
    ignoredRoutesToFetch: [...legalRoutes],
  },
}
